import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, HeartHandshakeIcon } from 'lucide-react';
export function FinalCTA() {
  return <section id="descarga" className="py-24 px-4 bg-gradient-to-br from-purple-dark via-purple to-purple-light text-white text-center relative overflow-hidden" data-id="element-38">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-39" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-41">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-balance" data-id="element-42">
            Por solo <span className="text-gold" data-id="element-43">$17</span> obtienes control
            financiero que apps gringas no dan.
          </h2>

          <p className="text-xl text-cream/90 max-w-2xl mx-auto font-body" data-id="element-44">
            Plantillas listas, en español, para tu vida real. Duerme sin peso en
            el pecho. Compra ahora y empieza hoy.
          </p>

          <div className="pt-8 flex flex-col items-center space-y-6" data-id="element-45">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            boxShadow: ['0px 0px 0px rgba(245, 158, 11, 0)', '0px 0px 30px rgba(245, 158, 11, 0.6)', '0px 0px 0px rgba(245, 158, 11, 0)']
          }} transition={{
            boxShadow: {
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} className="w-full sm:w-auto px-10 py-5 bg-gold hover:bg-gold-light text-charcoal font-bold text-2xl rounded-full shadow-2xl transition-colors" onClick={() => window.open('https://imperiodigitalmaster.com/cart/47661069205696:1', '_blank')} data-id="element-46">
              ¡DESCARGA AHORA!
            </motion.button>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-cream/80 font-medium" data-id="element-47">
              <span className="flex items-center gap-2" data-id="element-48">
                <ClockIcon className="w-5 h-5 text-gold" data-id="element-49" /> Instantáneo
              </span>
              <span className="flex items-center gap-2" data-id="element-50">
                <ShieldCheckIcon className="w-5 h-5 text-gold" data-id="element-51" /> Acceso
                vitalicio
              </span>
              <span className="flex items-center gap-2" data-id="element-52">
                <HeartHandshakeIcon className="w-5 h-5 text-gold" data-id="element-53" /> Soporte
                incluido
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}